<template>
  <span></span>
</template>

<script setup>

import { onMounted } from "vue"

import { useRegisterSW } from 'virtual:pwa-register/vue'

import { useToastsStore } from "@/store/toasts";

const toastsStore = useToastsStore();


let intervalMS = 30 * 60 * 1000 // 30 minutes

if (ENVIRONMENT != "production")
  intervalMS = 1 * 60 * 1000 // 60 seconds



const messageHandler = async (event) => {
  if (event.data && event.data.type === 'newServiceWorker') {

    toastsStore.toast({
      title: 'Aggiornamento',
      text: 'Aggiornamento ricevuto ed applicato, riavvio in 5 secondi...',
      type: 'success',
      duration: 5000,
      showUICountdown: true,
      sound: "update",
      callbackOnHide: updateApplication
    })
  }
}


const {
  // offlineReady,
  // needRefresh,
  updateServiceWorker,
} = useRegisterSW({

  onRegisteredSW(swScriptUrl, registration) {
    console.log("🧙‍♂️ onRegistered :: start interval to check for update")
    console.log("🧙‍♂️", swScriptUrl)
    console.log("🧙‍♂️", registration)
    registration && setInterval(() => {
      console.log("❔ checking for update")
      registration.update()
    }, intervalMS)

  },

  onNeedRefresh() {
    console.log("🧙‍♂️ onNeedRefresh")
  },

  onUpdateFound() {
    console.log("🧙‍♂️ onUpdateFound")
    toastsStore.toast({
      title: 'Aggiornamento trovato',
      text: 'Aggiornamento trovato',
      duration: 5000
    })
  },

  onOfflineReady() {
    console.log("🧙‍♂️ onOfflineReady")

    toastsStore.toast({
      title: 'Utilizzo offline',
      text: 'Applicazione pronta per essere utilizzata offline',
      type: 'success',
      duration: 5000
    })
  },

  onRegisterError(error) {
    console.log('❌ SW registration error', error);
    toastsStore.toast({
      title: 'Errore',
      text: 'Errore durante la registrazione del Service Worker',
      type: 'error',
      duration: 50000
    })
  },

})

onMounted(() => {
  console.log("✅ reload-prompt mounted")

  navigator?.serviceWorker?.addEventListener('message', messageHandler);
})


const updateApplication = async () => {

  await updateServiceWorker()

  console.log("⏳ restartAfterUpdate")
  navigator?.serviceWorker?.removeEventListener('message', messageHandler)
  window.location.reload()
}



</script>
